module.exports = __webpack_public_path__ + "static/ND_Patientsite_homepage_slider3-c02e49c57db28a875958c87cee195d6d.png";